import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import Login from "./pages/Login"
import TwoFA from "./pages/TwoFA"
import Setup2FA from "./pages/Setup2FA"
import LogViewer from "./pages/LogViewer"
import Admin from "./pages/Admin"

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/2fa" element={<TwoFA />} />
        <Route path="/logs" element={<LogViewer />} />
        <Route path="/2fa/setup" element={<Setup2FA />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </Router>
  )
}

export default App
